// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"19ca7827","53":"c1d6a04c","150":"92822c61","220":"f4a516f5","363":"7f29c563","440":"bd07a13b","477":"0284f4b0","496":"afea777b","812":"f1bd057b","950":"be463948"}[chunkId] + ".chunk.js";
};